export default __webpack_public_path__ + "static/media/i (13).19dd4991.jpg";